<template>
  <v-container>
    <v-card class="shadowCard">
      <v-card-title primary-title>
        <span class="text-caption">Datos Fiscales</span>
      </v-card-title>

      <v-card-text>
        Llenar desde PDF
        <v-btn
          color="info"
          dark
          small
          rounded
          @click="triggerFileInput"
        >
          Cargar documento
        </v-btn>
        <input
          ref="archivo"
          type="file"
          accept=".pdf"
          style="display: none"
          @change="onFileChange"
        />
      </v-card-text>

      <v-card-text>
        <v-form ref="form" v-model="valid">
            <v-row>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.razon_social"
                label="Razón Social"
                filled
                hide-details
                dense
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.rfc"
                label="RFC"
                filled
                hide-details
                dense
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <span>{{ sugerenciaRegimen }}</span>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.regimen_fiscal"
                :items="regimen"
                label="Selecciona regimen"
                hide-details
                item-text="regimen"
                item-value="idregimen_fiscal"
                :rules="requiredRule"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.direccion"
                label="Dirección"
                filled
                hide-details
                dense
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <span>{{ sugerenciaSeleccionarMunicipio }}</span>
              <v-autocomplete
                filled
                dense
                clearable
                v-model="editedItem.idmunicipios"
                :items="municipios"
                label="Selecciona municpio"
                hide-details
                item-text="nombre"
                item-value="idmunicipios"
                :rules="requiredRule"
              >
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.cp"
                label="CP"
                filled
                hide-details
                dense
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field
                v-model="editedItem.correo"
                label="Correo"
                filled
                hide-details
                dense
                :rules="emailRules"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="editedItem.telefono"
                label="Teléfono"
                filled
                hide-details
                dense
                :rules="requiredRule"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-file-input
                accept=".pdf"
                placeholder="Selecciona la constancia"
                prepend-icon="mdi-file"
                label="Selecciona la constancia"
                v-model="file"
                filled
              ></v-file-input>

              <embed :src="url + editedItem.constancia" type="application/pdf" width="100%" height="600px" v-if="editedItem.constancia"/>
            </v-col>

            <!-- Texto al final -->
            <v-col v-if="file" cols="12" class="mb-4 text-caption grey--text">
              Puedes corroborar que la información sea correcta con el QR de tu constancia.<br>
              <a :href="linkQR" target="_blank">{{ linkQR }}</a>
            </v-col>

          </v-row>
          </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          dark
          small
          rounded
          @click="save"
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>

    <Alerta   v-if="respuestaAlerta"  :parametros="parametros"/>
    <Loader   v-if="cargar"           :loader="loader"/>

  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

// Componentes
import Alerta          from '@/components/alertas/Alerta.vue'
import Loader          from '@/components/alertas/Loader.vue'

// Mixins
import  validarErrores from '@/mixins/validarErrores.js';

// Leer PDF
import * as pdfjsLib from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import jsQR from "jsqr";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorker;

export default {
  components:{
    Alerta,
    Loader
  },

  mixins:[validarErrores],

  computed:{
    	...mapGetters( 'login', [ 'getUsuarioLMS', 'getDatosUsuarioLMS']),

  },

  props:[
    'perfil',
    'iderp'
  ],

  data: () => ({
    // Respuesta Alerta
    respuestaAlerta: false,
    success:false,
    parametros: {
      dialogError: false,
      mensaje: '',
      color: ''
    },
    // Loader
    loader: true,
    cargar: false,

    // Modal
    modoVista: 1, // 1-. Editar, 2-. Guardar
    disabled: true,
    valid: true,

    // Datos fiscales
    editedIndex: -1,
    sugerenciaSeleccionarMunicipio: '',
    sugerenciaRegimen: '',
    editedItem: {
      iddatosfiscales:0,
      id_alumno:0,
      rfc:'',
      regimen_fiscal:'',
      direccion:'',
      idmunicipios:'',
      cp:'',
      telefono:'',
      correo:'',
      razon_social:'',
      constancia:''
    },

    defaultItem: {
      iddatosfiscales:0,
      id_alumno:0,
      rfc:'',
      regimen_fiscal:'',
      direccion:'',
      idmunicipios:'',
      cp:'',
      telefono:'',
      correo:'',
      razon_social:'',
      constancia:''
    },

    requiredRule: [(v) => !!v || 'Este campo es obligatorio'],
    emailRules: [
      v => !!v || 'El correo es obligatorio',
      v => /.+@.+\..+/.test(v) || 'Correo inválido'
    ],

    alumnos:[],
    municipios:[],
    regimen:[],
    file: null,
    url:'',
    constancia:'',
    linkQR: '',

  }),
  computed: {

  },

  watch: {

  },

  async created() {
    this.url   =  process.env.NODE_ENV == 'development' ?
    'http://localhost:3001/constancia-fiscal/' :
    process.env.VUE_APP_RUTA_API + 'constancia-fiscal/'

    console.log( this.url )
    await this.initialize()
    await this.getMunicipios()
    await this.getRegimen()
  },

  methods: {

      async initialize () {
        this.archivo = null
      	this.cargar = true

        await this.$http.get(`constancia.alumno/${ this.iderp }`)
        .then(response => {
          if (response.data && response.data.length > 0) {
            this.editedItem = response.data[0];
          } else {
            // Si no hay datos, reinicia al objeto por defecto
            this.editedItem = Object.assign({}, this.defaultItem);
          }
          this.cargar = false;
        })
        .catch(error => {
          this.validarError(error.response.data.message)
          this.cargar = false
        })

      },

      getMunicipios () {
      	this.cargar = true
        this.municipios = []
        return this.$http.get('facturas.municipios').then(response=>{
        	this.municipios = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getRegimen () {
      	this.cargar = true
        this.regimen = []
        return this.$http.get('facturas.regimen.fiscal').then(response=> {
        	this.regimen = response.data
        	this.cargar      = false
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.datosFiscales.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        this.editedIndex = this.datosFiscales.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },

      deleteItemConfirm () {
      	// Lo mandapos por el EP
        this.editedItem.deleted = 1
        this.$http.put('datos.fiscales.update/' + this.editedItem.iddatosfiscales, this.editedItem).then(response=>{
          this.validarSuccess( response.data.message )
          this.initialize()
          this.file = null
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },
      async save () {

        const esValido = this.$refs.form.validate();

        if (!esValido) {
          this.validarErrorDirecto("Llena los campos vacíos");
          return;
        }

        // Nombre del archivo que se guardo
        let nombre_archivo = null

        this.editedItem.reg_nuevo_municipio = this.sugerenciaSeleccionarMunicipio

        // Solo es es imagen, si no, se va vacío
        if( this.file ){
          nombre_archivo = await this.grabarImagen( ).then( response => response ).catch( error => { return this.validarError(error) })
        }


      	// Cargamos al usuario que hizo el cambio
        this.editedItem['id_alumno'] = this.iderp
      	this.editedItem.constancia    = nombre_archivo ? nombre_archivo.nombre : this.editedItem.constancia
	      this.cargar = true

        if (this.editedItem && this.editedItem.iddatosfiscales !== 0 ) {
	        // Lo mandapos por el EP
          this.$http.put('datos.fiscales.update/' + this.editedItem.iddatosfiscales, this.editedItem).then(response=>{
            this.validarSuccess( response.data.message )
          	this.initialize()
            this.file = null
	        }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })

        } else {
	        // Lo mandapos por el EP
          this.$http.post('datos.fiscales.add', this.editedItem).then(response=>{
          	this.validarSuccess( response.data.message )
            this.initialize()
            this.file = null
          }).catch( error =>{
            this.validarError( error.response.data.message )
          }).finally( () => { this.cargar = false })
        }
      },

      grabarImagen( ){
        return new Promise((resolve,reject)=>{
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo
          formData.append("file", this.file);

          this.$http.post("guardar.constancia", formData).then( response => {
            resolve( response.data )
          }).catch( error =>{
            reject( error )
          }).finally( () => { this.cargar = false })
        })
      },

      validarSuccess( mensaje ){
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true
        this.parametros.color        = 'success'
        this.respuestaAlerta         = true
      },

      validarError ( value ) {
        this.cargar = false
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true
        }
      },

      validarErrorDirecto ( mensaje ) {
        this.cargar = false
        this.parametros.mensaje      = mensaje
        this.parametros.dialogError  = true
        this.parametros.color        = '#FF2C2C'
        this.respuestaAlerta = true
    	},

      triggerFileInput() {
        this.$refs.archivo.click();
      },

      onFileChange(e) {
        this.archivo = e.target.files[0]; // Se guarda en data
        this.file = this.archivo;
         this.leerDocumento();
      },

      async leerDocumento() {

        const file = this.archivo;
        if (!file) return;

        const fileReader = new FileReader();

        fileReader.onload = async (e) => {
          const typedarray = new Uint8Array(e.target.result);

          // Cargar el PDF
          const pdf = await pdfjsLib.getDocument(typedarray).promise;

          // ------------------------
          // 🔎 Leer QR de la primera página
          // ------------------------
          const primeraPagina = await pdf.getPage(1);
          const viewport = primeraPagina.getViewport({ scale: 2.0 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await primeraPagina.render({ canvasContext: context, viewport }).promise;

          const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
          const qrCode = jsQR(imageData.data, canvas.width, canvas.height);

          if (qrCode) {
            this.linkQR = qrCode.data; // puedes guardarlo en tu modelo o mostrarlo en pantalla
          } else {
            this.linkQR = 'Por favor revisa tu constancia, o escanea el QR de la constancia con tu celular para veriticar la información'
          }
          // ------------------------

          // iniciarlizar
          this.editedItem.razon_social = ''
          this.editedItem.rfc = ''
          this.editedItem.cp = ''
          this.editedItem.direccion = ''
          this.sugerenciaSeleccionarMunicipio = ''
          this.editedItem.regimen_fiscal = ''
          this.sugerenciaRegimen = ''

          for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const content = await page.getTextContent();


            let esRazonSocial = false
            let esRFC = false
            let esDireccion = false
            let esMunicipio = false
            // aux para municipio
            let federativa = false
            let esCP = false
            let esRegimen = false

            content.items.map(item => {

              if( item.str === 'Registro Federal de Contribuyentes') return esRazonSocial = true;
              if( item.str.trim() === 'Nombre, denominación o razón' )return esRazonSocial = false;
              if( esRazonSocial ) {
                // Si ya hay texto entonces pon un espacio en blanco y sigue escribiendo la razon
                this.editedItem.razon_social.length ?
                  this.editedItem.razon_social += ` ${ item.str }` :
                  // Si razon esta vacio solo pon el texto
                  this.editedItem.razon_social += item.str
              }

              if( item.str === 'RFC:') return esRFC = true;
              if( esRFC ){
                this.editedItem.rfc += item.str
                return esRFC = false;
              }

              if( item.str.includes('Postal:') ) return esCP = true;
              if( item.str.includes('Tipo') )return esCP = false;
              if( esCP ) this.editedItem.cp += item.str

              if(
                // Valida Tipo y Nombre de vialidad
                // Para validar tipo 2
                item.str === 'Tipo de Vialidad:' ||
                item.str === 'Nombre de Vialidad:' ||
                // Para validar tipo 1
                item.str === 'Vialidad:' ||

                // Validar numero exterior
                // Para validdar tipo 2
                item.str === 'Número Exterior:' ||
                // Para validdar tipo 1
                item.str === 'Exterior:' ||
                item.str === 'Interior:' ||
                item.str === 'la Colonia:' ||
                item.str === 'Nombre de la Colonia:'
                &&
                !esDireccion
              ) return esDireccion = true;
              if(
                // Valida Tipo y Nombre de vialidad
                // Para validar tipo 2
                item.str === 'Nombre de Vialidad:' ||
                item.str === 'Número Exterior:' ||
                // Para validar tipo 1
                item.str === 'Nombre' ||

                item.str === 'Número' ||
                item.str === 'Número Interior:' ||
                item.str === 'Nombre de la Localidad:'
                && esDireccion
              ) return esDireccion = false;
              if( esDireccion ) this.editedItem.direccion += `${ item.str } `


              if( item.str.includes('Territorial:') ){
                return esMunicipio = true;
              }
              if( item.str.includes('Federativa:') )
              {
                federativa = true
                return esMunicipio = true;
              }

              if( item.str === 'Nombre ' ||
              item.str === 'de' ||
              item.str.includes('Entre')
              ){
                return esMunicipio = false;
              }

              if( esMunicipio ){
                if(federativa){
                  this.sugerenciaSeleccionarMunicipio = `${ this.sugerenciaSeleccionarMunicipio.trim() }, `
                  federativa = false
                }
                this.sugerenciaSeleccionarMunicipio +=
                //this.sugerenciaSeleccionarMunicipio.length ?
                `${ item.str } `
              }

              if( item.str === '2] de [' || item.str.includes('Página [2]') ) esRegimen = true;

              if( esRegimen ) {
                const regimenEncontrado = this.regimen.find(r =>
                r.regimen === item.str ||
                (
                  (r.regimen.includes(item.str) || item.str.includes(r.regimen))
                  && item.str.length > 10
                )
                );

                if( regimenEncontrado ){
                  this.sugerenciaRegimen = regimenEncontrado.regimen;
                  this.editedItem.regimen_fiscal = regimenEncontrado.idregimen_fiscal;
                  esRegimen = false;
                }
              }

            })

            this.sugerenciaSeleccionarMunicipio = this.sugerenciaSeleccionarMunicipio.trim()
            const municipioEncontrado = this.municipios.find(m => m.nombre === this.sugerenciaSeleccionarMunicipio )

            if (municipioEncontrado) {
              this.editedItem.idmunicipios = municipioEncontrado.idmunicipios;
            }

            if( this.perfil.email ) this.editedItem.correo = this.perfil.email
            if( this.perfil.celular ) this.editedItem.telefono = this.perfil.celular

            this.editedItem.direccion.trim()

          }

        };

        fileReader.readAsArrayBuffer(file);
      },

    },

}
</script>
